module.exports = __webpack_public_path__ + "media/images/application/template/logos/ssa-logo-276c45eb660d1c8909466567e8dc2882.png";